/* src/app/modules/taxes/model-180/model-180.component.css */
:host {
  --m180-brand: #e3fd64;
  --m180-brand-d: #4d7a00;
  --m180-brand-bg: rgba(227, 253, 100, 0.08);
  --m180-text: #1a1d23;
  --m180-muted: #6b7280;
  --m180-border: #e5e7eb;
  --m180-surface: #ffffff;
  --m180-radius: 10px;
  --m180-shadow: 0 2px 8px rgba(0,0,0,0.07);
  display: block;
}
.m180-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.m180-header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.m180-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: var(--m180-brand-bg);
  flex-shrink: 0;
}
.m180-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.m180-header__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: var(--m180-text);
  line-height: 1.2;
}
.m180-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--m180-muted);
}
.m180-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.m180-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px !important;
}
.m180-alerts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.m180-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(227, 253, 100, 0.1);
  border: 1px solid rgba(227, 253, 100, 0.4);
  border-left: 4px solid var(--m180-brand);
  border-radius: var(--m180-radius);
}
.m180-alert__text {
  font-size: 13px;
  color: var(--m180-text);
}
.m180-alert__link {
  font-size: 12px;
  font-weight: 600;
  color: var(--m180-brand-d);
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
  padding: 0;
}
.m180-alert__link:hover {
  text-decoration: underline;
}
.m180-card {
  background: var(--m180-surface);
  border: 1px solid var(--m180-border);
  border-radius: var(--m180-radius);
  box-shadow: var(--m180-shadow);
  overflow: hidden;
}
.m180-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--m180-brand);
}
.m180-card__head mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: var(--m180-brand-d);
  opacity: .9;
}
.m180-card__head-label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--m180-brand-d);
}
.m180-card__body {
  padding: 16px;
}
.m180-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
}
.m180-fields > * {
  flex: 1 1 200px;
  min-width: 0;
}
.m180-fields app-input,
.m180-fields app-select {
  display: block;
  width: 100%;
}
.m180-native-select,
.m180-input-plain {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid var(--m180-border);
  border-radius: 8px;
  font-size: 13px;
  color: var(--m180-text);
  background: #fff;
  box-sizing: border-box;
  height: 40px;
}
.m180-native-select:focus,
.m180-input-plain:focus {
  outline: none;
  border-color: var(--m180-brand);
  box-shadow: 0 0 0 2px rgba(227, 253, 100, 0.35);
}
.m180-input-plain[readonly] {
  background: #f9fafb;
  color: var(--m180-muted);
}
.m180-field-label {
  display: block;
  font-size: 12px;
  color: var(--m180-muted);
  margin-bottom: 4px;
}
.m180-subhead {
  display: block;
  background: var(--m180-brand);
  color: var(--m180-brand-d);
  padding: 8px 12px;
  font-weight: 600;
  font-size: 13px;
  border-radius: 6px;
  margin: 4px 0 12px;
}
.m180-table-wrap {
  overflow-x: auto;
}
.m180-list-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
}
.m180-list-table th,
.m180-list-table td {
  padding: 7px 10px;
  border-bottom: 1px solid var(--m180-border);
  color: var(--m180-text);
  vertical-align: middle;
}
.m180-list-table th {
  font-size: 11px;
  font-weight: 600;
  color: var(--m180-muted);
  background: #f9fafb;
  text-align: left;
}
.m180-list-table tr:last-child td {
  border-bottom: none;
}
.m180-list-empty {
  padding: 16px;
  text-align: center;
  font-size: 13px;
  color: var(--m180-muted);
}
.m180-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
}
.m180-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--m180-muted);
}
/*# sourceMappingURL=model-180.component.css.map */
